module.exports = __webpack_public_path__ + "static/media/festival.b7cb5412.jpg";